<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.0581 7.09153L7.92473 3.52487C3.13306 1.12487 1.1664 3.09153 3.5664 7.8832L4.2914 9.3332C4.49973 9.7582 4.49973 10.2499 4.2914 10.6749L3.5664 12.1165C1.1664 16.9082 3.12473 18.8749 7.92473 16.4749L15.0581 12.9082C18.2581 11.3082 18.2581 8.69153 15.0581 7.09153ZM12.3664 10.6249H7.8664C7.52473 10.6249 7.2414 10.3415 7.2414 9.99987C7.2414 9.6582 7.52473 9.37487 7.8664 9.37487H12.3664C12.7081 9.37487 12.9914 9.6582 12.9914 9.99987C12.9914 10.3415 12.7081 10.6249 12.3664 10.6249Z" fill="url(#paint0_linear_8699_31235)" />
    <defs>
      <linearGradient id="paint0_linear_8699_31235" x1="0.166675" y1="-10.1013" x2="24.7597" y2="-5.67031" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FECBD4" />
        <stop offset="0.345047" stop-color="#EB008B" stop-opacity="0.8" />
        <stop offset="0.857321" stop-color="#AA0085" stop-opacity="0.85" />
        <stop offset="1" stop-color="#8A008A" />
      </linearGradient>
    </defs>
  </svg>
</template>
